import { Divider } from "antd";

import { BaseDividerProps } from "./types";

const BaseDivider = ({ children, ...props }: BaseDividerProps) => {
  return (
    <div className={`base-divider`}>
      <Divider {...props}>{children}</Divider>
    </div>
  );
};

export default BaseDivider;
